/* BERG.KETTE Ad-Landings — Verhalten (ohne Fremdbibliotheken).
   window.BKAD = { basis, prefix, label, hero:{n}, grat:[…], seq:{name:{n,w,h}}, daten:'<url der Karten-Daten>' }
   Teile: Sonnenaufgang im Hero · Brücke in den Shop-Konfigurator · feste Leiste · Geschichte (Bildfolgen am Scrollen)
          · Weltkarte · Weihnachtsdatum · Warenkorb-Merkmal „Landingpage“. */
(function () {
  'use strict';
  var R = document.getElementById('bkad');
  if (!R || R.dataset.bereit) return;
  R.dataset.bereit = '1';
  var C = window.BKAD || {};
  var RUHIG = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var VORAB = /[?&]lat=/.test(location.search);           // Entwurf-Link: Konfigurator öffnet direkt den Entwurf
  function A(rel) { return C.basis + C.prefix + rel.replace(/\//g, '-'); }
  function $(s, el) { return (el || R).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || R).querySelectorAll(s)); }
  function klemm(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function weich(u) { u = klemm(u, 0, 1); return u * u * (3 - 2 * u); }
  function melde(aktion, daten) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'bk_landing', landing: C.label, aktion: aktion }, daten || {})); } catch (e) {}
  }

  /* ---------------------------------------------------------------- Shop-Kopf: Höhe für Hero, Bühne der Geschichte und Sprünge */
  // Im Shop steht der Kopf des Themes über der Seite (Ankündigung scrollt weg, der Kopf bleibt fest); in der Vorschau fehlt er → 0.
  (function shopKopf() {
    var teile = document.querySelectorAll('.shopify-section-group-header-group');
    if (!teile.length) return;
    function messen() {
      var ges = 0, fest = 0;
      Array.prototype.forEach.call(teile, function (s) {
        var h = s.offsetHeight, p = getComputedStyle(s).position;
        ges += h;
        if (p === 'sticky' || p === 'fixed') fest = Math.max(fest, h);
      });
      R.style.setProperty('--shopkopf', ges + 'px');
      R.style.setProperty('--oben', fest + 'px');
    }
    messen(); window.addEventListener('resize', messen);
  })();

  /* ---------------------------------------------------------------- Hero: Anhänger steigt wie die Sonne hinter dem Grat auf */
  (function hero() {
    var h = $('.hero'), g = $('.anhaenger'), bild = g && g.querySelector('image');
    if (!h || !g || !bild) return;
    var N = (C.hero && C.hero.n) || 1, CX = 540, R0 = 165, OBEN = +g.dataset.oben;
    // unten: Scheibe liegt in jeder Spalte unter der Silhouette (Gratlinie aus dem Höhenmodell, jede 4. Spalte)
    var grat = C.grat || [], unten = OBEN + 600;
    if (grat.length) {
      unten = 0;
      for (var x = CX - R0 + 1; x < CX + R0; x += 4) {
        var gy = grat[Math.round(x / 4)] || 1500, d = x - CX;
        unten = Math.max(unten, gy - (R0 - Math.sqrt(R0 * R0 - d * d)));
      }
      unten += 16;
    }
    var dy0 = unten - OBEN, start = null, bilder = [];
    for (var i = 1; i < N; i++) { var im = new Image(); im.src = A('hero/' + String(i).padStart(2, '0') + '.webp'); bilder.push(im); }
    function setze(y, k, rot) {
      g.setAttribute('transform', 'translate(0 ' + y.toFixed(1) + ') rotate(' + (rot || 0).toFixed(3) + ' ' + CX + ' ' + (OBEN - 690) + ')');
      var f = Math.round(k * (N - 1));
      if (f !== setze.f) { setze.f = f; bild.setAttribute('href', A('hero/' + String(f).padStart(2, '0') + '.webp')); }
    }
    function schritt(t) {
      if (start === null) start = t;
      var s = (t - start) / 1000, u = klemm((s - 0.25) / 2.6, 0, 1), e = 1 - Math.pow(1 - u, 3);
      var schwing = s > 2.6 ? Math.sin((s - 2.6) / 5.6 * Math.PI * 2) * 1.1 * Math.min(1, (s - 2.6) / 2) : 0;
      setze(dy0 * (1 - e), e, schwing);
      if (!document.hidden) requestAnimationFrame(schritt); else start = null;
    }
    var svg = $('.szene svg');
    function tag() { $$('path[data-tag]', svg).forEach(function (p) { p.style.fill = p.getAttribute('data-tag'); }); }
    // Hochformat-Bühne (Desktop rechts) zeigt den Anhänger größer, Querformat (Handy) zeigt mehr Grat
    function rahmen() {
      var r = svg.parentNode.getBoundingClientRect(); if (!r.width || !r.height) return;
      svg.setAttribute('viewBox', svg.getAttribute(r.width / r.height < 1 ? 'data-vb-hoch' : 'data-vb-quer'));
      try { var m = svg.getScreenCTM(); if (m) { var px = 12.5 / m.a; $$('.gipfel text', svg).forEach(function (t) { t.setAttribute('font-size', px.toFixed(1)); }); } } catch (e) {}
    }
    rahmen(); window.addEventListener('resize', rahmen);
    if (RUHIG || VORAB) { setze(0, 1, 0); h.classList.add('tag'); tag(); return; }
    setze(dy0, 0, 0);
    function los() { h.classList.add('tag'); tag(); requestAnimationFrame(schritt); }
    var erst = new Image(); erst.onload = erst.onerror = function () { setTimeout(los, 120); }; erst.src = A('hero/00.webp');
    document.addEventListener('visibilitychange', function () { if (!document.hidden) requestAnimationFrame(schritt); });
  })();

  /* ---------------------------------------------------------------- Brücke in den Shop-Konfigurator (#bkw-root) */
  var ziel = $('#gestalten');
  function wizard() { return document.getElementById('bkw-root'); }
  function kopfAbstand() { return parseFloat(R.style.getPropertyValue('--oben')) || 0; }
  function zumKonfigurator(sanft) {
    if (!ziel) return;
    var y = ziel.getBoundingClientRect().top + window.pageYOffset - kopfAbstand();
    window.scrollTo({ top: y, behavior: (sanft && !RUHIG) ? 'smooth' : 'auto' });
  }
  function karteBereit(cb) {
    var t0 = Date.now();
    (function warte() {
      var w = wizard();
      if (w && w.querySelector('.maplibregl-canvas, .gm-style, .bkw-map canvas')) return setTimeout(cb, 250);
      if (Date.now() - t0 > 9000) return cb();
      setTimeout(warte, 150);
    })();
  }
  function suche(q) {
    var w = wizard(), inp = w && w.querySelector('.bkw-search');
    if (!inp) return;
    var auf1 = w.querySelector('.bkw-step.is-active');
    if (auf1 && auf1.getAttribute('data-stepkey') !== 'berg') {
      var z = w.querySelector('[data-goto="berg"]'); if (z) z.click();
    }
    karteBereit(function () {
      inp.value = q;
      try { inp.dispatchEvent(new KeyboardEvent('keydown', { key: 'Enter', bubbles: true, cancelable: true })); } catch (e) {}
    });
  }
  R.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-zum-konfigurator]');
    if (!a) return;
    (function () {
      e.preventDefault();
      melde('cta', { wo: a.getAttribute('data-zum-konfigurator') || '' });
      zumKonfigurator(true);
      // Am Anfang: Suchfeld im Konfigurator gleich bereit (Tastatur öffnet am Handy nur in derselben Geste)
      var w = wizard(), inp = w && w.querySelector('.bkw-search'), akt = w && w.querySelector('.bkw-step.is-active');
      if (inp && (!akt || akt.getAttribute('data-stepkey') === 'berg') && !inp.value) { try { inp.focus({ preventScroll: true }); } catch (x) {} }
    })();
  });
  // Entwurf-Links (Hero-Vorschläge, Kacheln): laden die Seite mit dem Entwurf neu, vorher mitschreiben, welcher es war
  R.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-beispiel]');
    if (a) melde('beispiel', { berg: a.getAttribute('data-beispiel'), wo: a.getAttribute('data-wo') || 'kachel' });
  });
  $$('form.suche').forEach(function (form) { form.addEventListener('submit', function (e) {
    e.preventDefault();
    var q = (form.querySelector('input').value || '').trim();
    melde(form.getAttribute('data-wo') || 'hero_suche', { suchbegriff: q ? 'ja' : 'leer' });
    zumKonfigurator(true);
    if (q) suche(q);
    else { var w = wizard(), inp = w && w.querySelector('.bkw-search'); if (inp) try { inp.focus({ preventScroll: true }); } catch (x) {} }
  }); });
  // Ereignisse des Konfigurators mitschreiben (nur Zähler, keine Inhalte)
  document.addEventListener('bkw:step', function (e) { melde('wizard_schritt', { schritt: e.detail && e.detail.step }); });
  document.addEventListener('bkw:render', function () { melde('wizard_vorschau'); });
  // Entwurf-Link: Kopf der Seite und des Schritts überspringen, damit die 3D-Vorschau gleich im Bild ist (nicht unter der Preisleiste)
  // (Das prefill-Ereignis kommt teils vor diesem Skript und der Browser springt danach noch zum Anker, daher: auf load und Schritt warten.)
  if (VORAB) (function () {
    var t0 = Date.now(), y0 = -1;
    function versuch() {
      var w = wizard(), akt = w && w.querySelector('.bkw-step.is-active');
      var a = akt && akt.getAttribute('data-stepkey') !== 'berg' && w.querySelector('.bkw-progress');
      if (a && a.offsetHeight && document.readyState === 'complete') {
        if (y0 >= 0 && Math.abs(window.pageYOffset - y0) > 120) return;   // inzwischen selbst gescrollt → nicht eingreifen
        window.scrollTo(0, a.getBoundingClientRect().top + window.pageYOffset - 8 - kopfAbstand()); return;
      }
      if (y0 < 0 && document.readyState === 'complete') y0 = window.pageYOffset;
      if (Date.now() - t0 < 15000) setTimeout(versuch, 150);
    }
    versuch();
  })();

  /* ---------------------------------------------------------------- feste Leiste unten (Handy) */
  (function leiste() {
    var fest = $('.fest'); if (!fest || !('IntersectionObserver' in window)) return;
    var sicht = { hero: true, gestalten: false, schluss: false, spur: false };
    function upd() { fest.classList.toggle('an', !sicht.hero && !sicht.gestalten && !sicht.schluss && !sicht.spur); }
    [['hero', '.hero'], ['gestalten', '#gestalten'], ['schluss', '.schluss'], ['spur', '.spur']].forEach(function (p) {
      var el = $(p[1]); if (!el) return;
      new IntersectionObserver(function (es) { sicht[p[0]] = es[0].isIntersecting; upd(); }, { threshold: p[0] === 'hero' ? 0.02 : (p[0] === 'spur' ? 0 : 0.12) }).observe(el);
    });
  })();

  /* ---------------------------------------------------------------- Bildfolgen (Canvas, schrittweise geladen) */
  function Folge(name, canvas, info) {
    this.name = name; this.c = canvas; this.n = info.n; this.w = info.w; this.h = info.h;
    this.img = new Array(this.n); this.ok = new Array(this.n); this.f = -1; this.geladen = false;
    this.cover = canvas.hasAttribute('data-cover');
  }
  Folge.prototype.laden = function () {
    if (this.geladen) return; this.geladen = true;
    var self = this, reihe = [], drin = {};
    [8, 4, 2, 1].forEach(function (st) { for (var i = 0; i < self.n; i += st) if (!drin[i]) { drin[i] = 1; reihe.push(i); } });
    if (!drin[self.n - 1]) reihe.push(self.n - 1);
    var lauf = 0, pos = 0;
    function weiter() {
      while (lauf < 6 && pos < reihe.length) {
        (function (i) {
          lauf++;
          var im = new Image(); im.decoding = 'async';
          im.onload = function () { self.ok[i] = true; lauf--; if (self.f < 0 || Math.abs(i - self.ziel) < Math.abs(self.f - self.ziel)) self.zeichne(self.ziel); weiter(); };
          im.onerror = function () { lauf--; weiter(); };
          im.src = A('seq/' + self.name + '/' + String(i).padStart(3, '0') + '.webp');
          self.img[i] = im;
        })(reihe[pos++]);
      }
    }
    weiter();
  };
  Folge.prototype.groesse = function () {
    var r = this.c.getBoundingClientRect(), d = Math.min(window.devicePixelRatio || 1, 2);
    var w = Math.round(r.width * d), h = Math.round(r.height * d);
    if (w && h && (this.c.width !== w || this.c.height !== h)) { this.c.width = w; this.c.height = h; this.f = -1; }
  };
  Folge.prototype.zeichne = function (k) {
    k = klemm(Math.round(k), 0, this.n - 1); this.ziel = k;
    var best = -1;
    for (var d = 0; d < this.n; d++) {
      if (k - d >= 0 && this.ok[k - d]) { best = k - d; break; }
      if (k + d < this.n && this.ok[k + d]) { best = k + d; break; }
    }
    if (best < 0 || best === this.f) return;
    this.groesse();
    var c = this.c, x = c.getContext('2d'), im = this.img[best];
    var s = this.cover ? Math.max(c.width / this.w, c.height / this.h) : Math.min(c.width / this.w, c.height / this.h);
    var w = this.w * s, h = this.h * s;
    x.clearRect(0, 0, c.width, c.height);
    x.drawImage(im, (c.width - w) / 2, (c.height - h) / 2, w, h);
    this.f = best;
  };

  /* ---------------------------------------------------------------- Geschichte: ein Schritt je Bildschirmhöhe */
  (function geschichte() {
    var spur = $('.spur'); if (!spur) return;
    var medien = $$('.medium', spur), schritte = $$('.schritt', spur), folgen = {};
    $$('canvas[data-seq]', spur).forEach(function (c) { var n = c.getAttribute('data-seq'); if (C.seq && C.seq[n]) folgen[n] = new Folge(n, c, C.seq[n]); });
    var orte = $$('.ort', spur), form = $('.form', spur), mass = form && form.querySelector('.mass b'), unter = $('.untertitel', spur);
    var aktiv = -1, schleife = null, t0 = 0;
    function laden() { ['erde', 'route', 'drauf', 'front'].forEach(function (n) { if (folgen[n]) folgen[n].laden(); }); }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { laden(); io.disconnect(); } }, { rootMargin: '700px 0px' });
      io.observe(spur);
    } else laden();
    function drauf(an) {   // Streiflicht dreht sich hin und her, solange die Draufsicht zu sehen ist
      var f = folgen.drauf; if (!f) return;
      if (!an || RUHIG) { if (schleife) cancelAnimationFrame(schleife); schleife = null; if (RUHIG) f.zeichne(f.n * 0.5); return; }
      if (schleife) return;
      t0 = performance.now();
      (function lauf(t) { var p = ((t - t0) / 9000) % 2; f.zeichne((p < 1 ? p : 2 - p) * (f.n - 1)); schleife = requestAnimationFrame(lauf); })(t0);
    }
    function upd() {
      var vh = window.innerHeight, idx = 0, t = 0;
      for (var i = 0; i < schritte.length; i++) {
        var r = schritte[i].getBoundingClientRect();
        if (r.top <= vh * 0.55) { idx = i; t = klemm((vh * 0.55 - r.top) / r.height, 0, 1); }
      }
      if (idx !== aktiv) {
        aktiv = idx;
        if (unter) {
          var quelle = schritte[idx].querySelector('.karte-text');
          unter.classList.add('weg');
          clearTimeout(unter._t);
          unter._t = setTimeout(function () { unter.innerHTML = quelle ? quelle.innerHTML : ''; unter.classList.remove('weg'); }, unter.innerHTML ? 180 : 0);
        }
        medien.forEach(function (m) { m.classList.toggle('an', +m.getAttribute('data-schritt') === idx); });
        melde('geschichte', { schritt: idx });
      }
      var art = medien[idx] && medien[idx].getAttribute('data-art');
      drauf(art === 'drauf');
      if (art === 'erde' && folgen.erde) folgen.erde.zeichne(weich(t * 1.15) * (folgen.erde.n - 1));
      if (art === 'route' && folgen.route) folgen.route.zeichne(t * 1.1 * (folgen.route.n - 1));
      if (art === 'front' && folgen.front) folgen.front.zeichne(Math.pow(klemm(t * 1.25, 0, 1), 0.8) * (folgen.front.n - 1));
      if (art === 'drauf') orte.forEach(function (o, k) { o.classList.toggle('an', RUHIG || t > 0.12 + k * 0.16); });
      if (art === 'form' && form) {
        var w = RUHIG ? 1 : weich((t - 0.22) / 0.5);
        form.style.setProperty('--w', (w * 100).toFixed(2) + '%');
        form.style.setProperty('--k', w > 0.01 && w < 0.99 ? 1 : 0);
        if (mass) mass.textContent = w > 0.5 ? mass.getAttribute('data-km') : mass.getAttribute('data-mm');
      }
      if (art === 'foto') { var im = medien[idx].querySelector('img'); if (im && !RUHIG) im.style.transform = 'scale(' + (1 + 0.06 * t).toFixed(4) + ')'; }
    }
    var wartet = false;
    function anfordern() { if (!wartet) { wartet = true; requestAnimationFrame(function () { wartet = false; upd(); }); } }
    window.addEventListener('scroll', anfordern, { passive: true });
    window.addEventListener('resize', function () { Object.keys(folgen).forEach(function (k) { folgen[k].f = -1; }); anfordern(); });
    upd();
  })();

  /* ---------------------------------------------------------------- Weltkarte: Landpunkte + gefertigte Stücke (füllt sich einmal) */
  (function weltkarte() {
    var box = $('.weltkarte'); if (!box || !C.daten) return;
    var c = box.querySelector('canvas'), D = null, gezeigt = 0, start = 0;
    function proj(lat, lng) { return [(lng + 180) / 360, (D.lat_n - lat) / (D.lat_n - D.lat_s)]; }
    function male(anteil) {
      var r = c.getBoundingClientRect(), d = Math.min(window.devicePixelRatio || 1, 2);
      c.width = Math.round(r.width * d); c.height = Math.round(r.height * d);
      var x = c.getContext('2d'), W = c.width, H = c.height, zw = W / D.gw, zh = H / D.gh, rp = Math.max(0.9, Math.min(zw, zh) * 0.3);
      x.clearRect(0, 0, W, H); x.fillStyle = '#B4B9BC';
      for (var i = 0; i < D.land.length; i++) { x.beginPath(); x.arc((D.land[i][0] + 0.5) * zw, (D.land[i][1] + 0.5) * zh, rp, 0, 6.2832); x.fill(); }
      var n = Math.round(D.stuecke.length * anteil), rs = Math.max(1.6, Math.min(zw, zh) * 0.42);
      x.fillStyle = '#B8963A'; x.strokeStyle = 'rgba(255,255,255,.85)'; x.lineWidth = Math.max(0.8, rs * 0.35);
      for (var k = 0; k < n; k++) { var p = proj(D.stuecke[k][0], D.stuecke[k][1]); x.beginPath(); x.arc(p[0] * W, p[1] * H, rs, 0, 6.2832); x.fill(); x.stroke(); }
    }
    function namen() {
      (D.namen || []).forEach(function (nm, i) {
        var p = proj(nm[1], nm[2]), s = document.createElement('span');
        s.className = 'name' + (nm[3] === 'l' ? ' links' : '') + (nm[4] ? '' : ' mobil-aus');
        s.style.setProperty('--x', (p[0] * 100).toFixed(2) + '%'); s.style.setProperty('--y', (p[1] * 100).toFixed(2) + '%');
        s.textContent = nm[0]; box.appendChild(s);
      });
    }
    function lauf(t) {
      if (!start) start = t;
      var u = RUHIG ? 1 : klemm((t - start) / 2400, 0, 1);
      male(u); if (u < 1) requestAnimationFrame(lauf); else box.classList.add('an');
    }
    var io = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting || gezeigt) return; gezeigt = 1; io.disconnect();
      fetch(C.daten).then(function (r) { return r.json(); }).then(function (d) {
        D = d; box.style.setProperty('--ar', (D.gw / D.gh).toFixed(3)); namen(); requestAnimationFrame(lauf);
        window.addEventListener('resize', function () { male(1); });
      }).catch(function () {});
    }, { rootMargin: '200px 0px' });
    io.observe(box);
  })();

  /* ---------------------------------------------------------------- Hero: gefertigte Stücke hängen im Bild und drehen sich aus */
  // Je Stück ein kurzes Video aus Janniks Szene (3 s, Kette läuft oben aus dem Bild). Bis es spielt, steht sein erstes Bild
  // als <img>. Kurz nachdem das Stück ausgeschwungen ist, blendet das nächste über; das folgende Video lädt schon vorher.
  (function parade() {
    var b = $('.parade-buehne'); if (!b) return;
    var teile = $$('.teil', b), takt = $('.takt', b); if (!teile.length) return;
    var HALTEN = 1100, OHNE = 3800, klein = window.innerWidth < 700, ua = navigator.userAgent;
    // Transparentes Video: Safari/iPhone (auch In-App-Browser, alle WebKit) können HEVC mit Alpha, die anderen VP9-WebM
    var apple = /iP(hone|ad|od)/.test(ua) || (/Safari\//.test(ua) && !/Chrome|Chromium|Edg|OPR|Firefox/.test(ua));
    var art = apple ? 'mov' : 'webm', geht = !!document.createElement('video').canPlayType(apple ? 'video/mp4; codecs="hvc1"' : 'video/webm; codecs="vp9"');
    var i = 0, uhr = null, pause = false, knoepfe = null;
    function bild(t) { var im = t.querySelector('img'); if (im && im.dataset.src) { im.src = im.dataset.src; im.removeAttribute('data-src'); } }
    function video(t) {
      var v = t.querySelector('video'); if (!v || !geht || v.dataset.kaputt) return null;
      if (!v.getAttribute('src')) {
        v.src = (klein && v.getAttribute('data-' + art + '-m')) || v.getAttribute('data-' + art); v.preload = 'auto';
        // Prüfen, ob die Transparenz ankommt (Ecke oben links ist leer): sonst lieber das Standbild als ein schwarzes Rechteck
        v.addEventListener('loadeddata', function () {
          try { var c = document.createElement('canvas'); c.width = c.height = 8; var x = c.getContext('2d'); x.drawImage(v, 0, 0, 8, 8);
            if (x.getImageData(0, 0, 1, 1).data[3] > 40) { v.dataset.kaputt = 1; t.classList.remove('laeuft'); v.removeAttribute('src'); v.load(); }
          } catch (e) {}
        }, { once: true });
        try { v.load(); } catch (e) {}
      }
      return v;
    }
    function spiele(k) {
      var t = teile[k], v = RUHIG ? null : video(t);
      if (!v) return weiter(OHNE);
      try { v.currentTime = 0; } catch (e) {}
      v.onplaying = function () {
        if (i !== k || v.dataset.kaputt) return; t.classList.add('laeuft');
        var n = teile[(k + 1) % teile.length]; bild(n); video(n);
      };
      v.onended = function () { if (i === k) weiter(HALTEN); };
      v.onerror = function () { if (i === k) weiter(OHNE); };
      function los() { if (i !== k) return; var p = v.play(); if (p && p.catch) p.catch(function () { if (i === k) weiter(OHNE); }); }
      if (v.readyState >= 3) los(); else v.addEventListener('canplay', los, { once: true });
    }
    function weiter(ms) { clearTimeout(uhr); if (teile.length > 1) uhr = setTimeout(function naechstes() { if (pause || document.hidden) { uhr = setTimeout(naechstes, 600); return; } zeige(i + 1); }, ms); }
    function zeige(k) {
      k = (k + teile.length) % teile.length; if (k === i) return;
      var alt = teile[i], av = alt.querySelector('video');
      alt.classList.remove('an'); setTimeout(function () { if (!alt.classList.contains('an')) { alt.classList.remove('laeuft'); if (av) av.pause(); } }, 900);
      i = k; bild(teile[i]); teile[i].classList.add('an');
      if (knoepfe) knoepfe.forEach(function (x, j) { x.classList.toggle('an', j === i); });
      clearTimeout(uhr); spiele(i);
    }
    if (takt && teile.length > 1) {
      teile.forEach(function (t, k) {
        var x = document.createElement('button'); x.type = 'button';
        x.setAttribute('aria-label', (t.querySelector('b') || {}).textContent || String(k + 1));
        x.addEventListener('click', function () { zeige(k); melde('parade', { stueck: k }); });
        takt.appendChild(x);
      });
      knoepfe = $$('button', takt); knoepfe[0].classList.add('an');
    }
    window.addEventListener('load', function () { setTimeout(function () { teile.forEach(bild); }, 300); });
    b.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') pause = true; });
    b.addEventListener('pointerleave', function () { pause = false; });
    var x0 = null;
    b.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    b.addEventListener('touchend', function (e) { if (x0 === null) return; var d = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(d) > 40) zeige(i + (d < 0 ? 1 : -1)); }, { passive: true });
    // Hero außer Sicht: Video anhalten, beim Zurückkommen weiterlaufen lassen
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) {
      var v = teile[i].querySelector('video'); if (!v || !v.getAttribute('src')) return;
      if (!es[0].isIntersecting) v.pause(); else if (!v.ended && teile[i].classList.contains('laeuft')) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }).observe(b);
    if (document.readyState === 'complete') spiele(0); else window.addEventListener('load', function () { spiele(0); });
  })();

  /* ---------------------------------------------------------------- Was alles geht: Vergleich, Überhöhung, Wasser */
  function einmalSichtbar(el, cb, schwelle, rand) {
    if (!el) return;
    if (!('IntersectionObserver' in window)) return cb();
    var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); cb(); } }, { threshold: schwelle || 0, rootMargin: rand || '0px' });
    io.observe(el);
  }
  $$('[data-vergleich]').forEach(function (v) {
    var inp = v.querySelector('input'), angefasst = false;
    function setze(w) { v.style.setProperty('--w', w + '%'); }
    inp.addEventListener('input', function () { angefasst = true; setze(inp.value); });
    inp.addEventListener('pointerdown', function () { angefasst = true; melde('vergleich'); });
    setze(inp.value);
    einmalSichtbar(v, function () {
      if (RUHIG) return;
      var t0 = performance.now(), wege = [[50, 88, 0], [88, 14, 900], [14, 50, 1900]], ende = 2600;
      (function lauf(t) {
        if (angefasst) return;
        var e = t - t0, w = 50;
        for (var k = 0; k < wege.length; k++) { var a = wege[k], b2 = wege[k + 1] ? wege[k + 1][2] : ende; if (e >= a[2] && e < b2) w = a[0] + (a[1] - a[0]) * weich((e - a[2]) / (b2 - a[2])); }
        if (e >= ende) w = 50;
        setze(w.toFixed(2)); inp.value = w; if (e < ende) requestAnimationFrame(lauf);
      })(t0);
    }, 0.55);
  });
  $$('[data-hoehe]').forEach(function (h) {
    var c = h.querySelector('canvas'), inp = h.querySelector('input'), out = h.querySelector('output');
    if (!c || !C.seq || !C.seq.ueb) return;
    var f = new Folge('ueb', c, C.seq.ueb), ZS = (C.seq.ueb.zs || 2.5), angefasst = false;
    function setze(v) {
      v = klemm(+v, 0, 1); f.zeichne(v * (f.n - 1));
      if (out) out.textContent = (1 + (ZS - 1) * v).toFixed(1).replace('.', ',') + '×';
    }
    inp.addEventListener('input', function () { angefasst = true; setze(inp.value); });
    inp.addEventListener('pointerdown', function () { angefasst = true; melde('ueberhoehung'); });
    einmalSichtbar(h, function () { f.laden(); setze(inp.value); }, 0, '600px 0px');
    einmalSichtbar(h, function () {
      if (RUHIG) { inp.value = 1; setze(1); return; }
      setTimeout(function () {
        var t0 = performance.now();
        (function lauf(t) {
          if (angefasst) return;
          var v = weich((t - t0) / 2600); inp.value = v; setze(v); if (v < 1) requestAnimationFrame(lauf);
        })(t0);
      }, 500);
    }, 0.6);
    window.addEventListener('resize', function () { f.f = -1; setze(inp.value); });
  });
  $$('[data-wasser]').forEach(function (w) { einmalSichtbar(w, function () { w.classList.add('an'); }, 0.55); });

  /* ---------------------------------------------------------------- Weihnachtsdatum nur bis zum Bestellschluss */
  $$('[data-bis]').forEach(function (el) { if (new Date() > new Date(el.getAttribute('data-bis') + 'T23:59:59')) el.classList.add('weg'); });
  $$('[data-tage-bis]').forEach(function (el) {
    var t = Math.ceil((new Date(el.getAttribute('data-tage-bis') + 'T23:59:59') - new Date()) / 864e5);
    if (t > 1) el.textContent = 'noch ' + t + ' Tage'; else if (t === 1) el.textContent = 'bis morgen'; else if (t === 0) el.textContent = 'nur noch heute';
  });

  /* ---------------------------------------------------------------- Warenkorb-Merkmal: Bestellungen dieser Landing zuordnen */
  try {
    if (C.label && !sessionStorage.getItem('bkad-merkmal-' + C.prefix)) {
      sessionStorage.setItem('bkad-merkmal-' + C.prefix, '1');
      var a = {}; a.Landingpage = C.label; a['Landingpage-Besuch'] = new Date().toISOString().slice(0, 10);
      fetch(ROOT + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: a }) }).catch(function () {});
    }
  } catch (e) {}
  melde('ansicht', { vorab: VORAB ? 1 : 0 });
})();
